import clsx from 'clsx';
import React from 'react';

import IconTI from '@components/Images/Rebranding/IconTI';

interface HorizontalLogoDividerProps {
  className?: string;
}

const HorizontalLogoDivider = ({ className = '' }: HorizontalLogoDividerProps): JSX.Element => (
  <div
    className={clsx(
      "-before:translate-y-1/2 relative flex items-center justify-center before:absolute before:top-1/2 before:h-2 before:w-full before:bg-grayscale-beige before:content-['']",
      className
    )}
  >
    <IconTI className="z-10 h-36 w-64 bg-white text-primary-magenta" />
  </div>
);

export default HorizontalLogoDivider;
